import React, { useState } from "react";
import { PenLine } from "lucide-react";

const WriteBox = ({
  onTextChange,
  minHeight = "min-h-[18rem]",
  title = "Write your answer",
  helper = "Your response is saved when you move to the next screen.",
  placeholder = "Start writing...",
}) => {
  const [text, setText] = useState("");
  const words = text.trim().split(/\s+/).filter(Boolean).length;

  const handleChange = (event) => {
    const newText = event.target.value;
    setText(newText);
    onTextChange(newText);
  };

  return (
    <section className="overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm">
      <div className="flex flex-col gap-3 border-b border-slate-100 bg-white p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-purple-50 text-purple-700">
            <PenLine className="h-5 w-5" aria-hidden="true" />
          </span>
          <div>
            <p className="text-sm font-semibold uppercase text-purple-700">
              Response
            </p>
            <h3 className="text-xl font-extrabold text-gray-900">
              {title}
            </h3>
          </div>
        </div>

        <span className="w-fit rounded-md bg-slate-50 px-3 py-2 text-sm font-bold text-gray-700 ring-1 ring-slate-100">
          {words} words
        </span>
      </div>

      <div className="p-4">
        <textarea
          className={`w-full resize-y rounded-md border border-slate-200 bg-slate-50 p-4 text-sm leading-7 text-gray-800 outline-none transition placeholder:text-gray-400 focus:border-purple-400 focus:bg-white focus:ring-2 focus:ring-purple-100 ${minHeight}`}
          placeholder={placeholder}
          value={text}
          onChange={handleChange}
        />
        <p className="mt-2 text-xs font-medium text-gray-500">{helper}</p>
      </div>
    </section>
  );
};

export default WriteBox;
